import { TeamId } from '../types';

import { useTeams } from './useTeams';

const NO_TEAMS: TeamId[] = [];

/** Ids of the teams that currently deny their members access to Portainer. */
export function useTeamsDenyingPortainerAccess() {
  const query = useTeams(false, 0, {
    select: (teams) =>
      teams.filter((team) => team.DenyPortainerAccess).map((team) => team.Id),
  });

  return query.data ?? NO_TEAMS;
}

export function allTeamsDenyPortainerAccess(
  teamIds: TeamId[],
  denyingTeamIds: TeamId[]
) {
  return (
    teamIds.length > 0 && teamIds.every((id) => denyingTeamIds.includes(id))
  );
}

/**
 * The selected teams whose stored value differs from the toggle - the only ones
 * needing a write, so a team added to an already-denying selection is picked up
 * and an unchanged save writes nothing.
 */
export function getTeamsToApplyDenyPortainerAccess(
  selectedTeamIds: TeamId[],
  denyingTeamIds: TeamId[],
  denyPortainerAccess: boolean
) {
  return selectedTeamIds.filter(
    (id) => denyingTeamIds.includes(id) !== denyPortainerAccess
  );
}
